import TabPanel from "../Reusable/Tab";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import EditPickupRequest from "./EditPickupRequest";

const SwitchTab = (props: any) => {
  const {
    isLoading,
    data,
    handleAttachConsignment,
    handleToggleMarkAsDone,
    defaultValue,
    setDefaultValue,
    gridData,
    id,
    handlecheckConsignments,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    handleUpdate,
    openAddDriverPopup,
    openAddVehiclePopup,
    setOpenAddDriverPopup,
    setOpenAddVehiclePopup,
  } = props;

  return (
    <>
      <TabPanel
        tabTitle={["Update", "Documents"]}
        tabPanels={[
          <>
            <EditPickupRequest
              isLoading={isLoading}
              data={data}
              handleAttachConsignment={handleAttachConsignment}
              handleToggleMarkAsDone={handleToggleMarkAsDone}
              defaultValue={defaultValue}
              setDefaultValue={setDefaultValue}
              gridData={gridData}
              handlecheckConsignments={handlecheckConsignments}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
              handleAddDriver={handleAddDriver}
              isDriverLoading={isDriverLoading}
              handleUpdate={handleUpdate}
              openAddDriverPopup={openAddDriverPopup}
              openAddVehiclePopup={openAddVehiclePopup}
              setOpenAddDriverPopup={setOpenAddDriverPopup}
              setOpenAddVehiclePopup={setOpenAddVehiclePopup}
            />
          </>,
          <>
            <FileUpload object_id={id} />
          </>,
        ]}
      />
    </>
  );
};

export default SwitchTab;
